// Init
window.body = document.body;
window.table = '';

window.tinymceDefault = {
    path_absolute : '/',
    plugins: [
        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
        'searchreplace wordcount visualblocks visualchars code fullscreen',
        'insertdatetime media nonbreaking save table contextmenu directionality',
        'emoticons template paste textcolor colorpicker textpattern imagetools',
        'autoresize codemirror'
    ],
    toolbar1: 'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
    toolbar2: 'print preview media | forecolor backcolor emoticons',
    relative_urls: false,
    image_advtab: true,

    file_browser_callback: function (field_name, url, type, win) {
        var x = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
        var y = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;

        var cmsURL = '/laravel-filemanager?ajax_call=tinyMCE&field_name=' + field_name;

        if (type == 'image')
            cmsURL = cmsURL + '&type=Images';
        else
            cmsURL = cmsURL + '&type=Files';

        tinyMCE.activeEditor.windowManager.open({
            file: cmsURL,
            title: 'Filemanager',
            width: x * 0.8,
            height: y * 0.8,
            resizable: 'yes',
            close_previous: 'no'
        });
    },

    content_css: [
        '/winskey/css/slick.css',
        '/winskey/css/slick-theme.css',
        '/winskey/css/bootstrap.min.css',
        '/winskey/css/style.css'
    ],

    autoresize_on_init: true,
    autoresize_bottom_margin: 50,
    autoresize_min_height: 150,
    autoresize_max_height: 475,

    extended_valid_elements: '+div[*],+a[*],+span[*],+button[*]',
    valid_children: '+a[h1|h2|h3|h4|h5|h6|p|span|div|img]',
    force_br_newlines: true,
    force_p_newlines: false,
    forced_root_block: false,

    cleanup: false,
    relative_urls: false,
    convert_newlines_to_brs: false,

    codemirror: {
        indentOnInit: true,
        path: 'CodeMirror',
        config: {
            mode: 'htmlmixed',
            indentWithTabs: true,
            lineNumbers: true
        }
    }
};

Dropzone.autoDiscover = false;